/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".modalWidthBig[_ngcontent-%COMP%]{width:50%!important}.greenBadge[_ngcontent-%COMP%]{color:#4caf50;background:#4caf5033;padding:6px 15px;font-size:15px;border-radius:25px;font-weight:400;display:inline-block}"];
export { styles as styles };

